/**
 * Contact Form Button Styling Fix
 * Injects border styling into Shopify Forms shadow DOM
 * LSHOP-061 - Contact Us Form Override
 */

(function () {
  "use strict";

  // Wait for DOM to be ready
  function addButtonStyles() {
    const formsEmbed = document.querySelector("shopify-forms-embed");

    if (!formsEmbed || !formsEmbed.shadowRoot) {
      // Retry after a short delay if not found
      setTimeout(addButtonStyles, 100);
      return;
    }

    const shadowRoot = formsEmbed.shadowRoot;
    const submitButton = shadowRoot.querySelector('button[type="submit"]');

    if (!submitButton) {
      // Retry if button not found yet
      setTimeout(addButtonStyles, 100);
      return;
    }

    // Create a style element to inject into shadow DOM
    const style = document.createElement("style");
    style.textContent = `
      /* ========== BASE STYLES ========== */
      section[data-sizing="form-wrapper"] {
        max-width: 100% !important;
      }
      form {
        padding: 0 !important;
        padding-top: 1px !important;
        overflow: visible !important;
        gap: 20px !important;
      }

      /* Labels - use Camber font */
      label {
        font-family: Camber, sans-serif !important;
        color: #1C1C1C !important;
      }

      /* Input fields and textarea */
      input,
      textarea {
        font-family: Camber, sans-serif !important;
        border-radius: 2px !important;
      }

      input:focus,
      textarea:focus {
        outline: none !important;
      }

      /* Input fields and textarea placeholders */
      input::placeholder,
      textarea::placeholder {
        font-family: Camber, sans-serif !important;
        color: #797979 !important;
      }

      /* Submit Button */
      button[type="submit"] {
        border: 1px solid #1C1C1C !important;
        border-radius: 0 !important;
        padding: 12px 24px !important;
        font-family: Camber, sans-serif !important;
        font-size: 16px !important;
        font-weight: 600 !important;
        line-height: 20px !important;
        transition: all 0.2s ease !important;
        cursor: pointer !important;
        box-shadow: none !important;
        width: auto !important;
        max-width: fit-content !important;
        display: inline-block !important;
        margin: 0 !important;
        outline: none !important;
      }

      button[type="submit"] svg {
        fill: #1C1C1C !important;
      }

      button[type="submit"]:hover {
        background-color: #1C1C1C !important;
        color: white !important;
        filter: unset !important;
      }

      button[type="submit"]:hover svg {
        fill: white !important;
      }

      /* Hide Notice legend */
      fieldset[name="custom#consent"] legend {
        display: none !important;
      }

      /* Consent checkbox styling */
      ._checkboxFieldSet_1hja3_3 {
        margin: 0 !important;
        padding: 0 !important;
      }

      ._checkboxField_1hja3_3 {
        font-family: Camber, sans-serif !important;
        color: #1C1C1C !important;
      }

      ._checkboxField_1hja3_3 span._textBody_2aowh_10 {
        font-family: Camber, sans-serif !important;
        color: #1C1C1C !important;
        font-size: 16px !important;
        line-height: 20px !important;
        margin-top: -2px !important;
      }

      /* FIX: Disable pseudo :before that hides textarea label */
      ._formFieldContainer_1mxsl_5:has(textarea)::before {
        display: none !important;
        content: none !important;
      }

      ._formBannerContainer_z5ku3_1 ._formBannerHeading_z5ku3_9, ._formBannerContainer_z5ku3_1 ._textBody_2aowh_10 {
        font-size: 20px !important;
        line-height: 28px !important;
      }

      /* ========== DESKTOP LAYOUT 601) - 2 Column ========== */
      @media (min-width: 601px) {
        /* Form field container - 2 column grid */
        /* Label: 150px min + 100px spacing = 250px, gap input-(*) = 8px */
        ._formFieldContainer_1mxsl_5 {
          display: grid !important;
          grid-template-columns: 250px 1fr auto !important;
          align-items: center !important;
          column-gap: 8px !important;
          row-gap: 8px !important;
          position: relative !important;
          margin-top: 1px !important;
        }

        /* Label - static position on left */
        ._formFieldContainer_1mxsl_5 > label._formInputFieldLabel_1mxsl_38 {
          position: static !important;
          transform: none !important;
          order: -1 !important;
          top: auto !important;
          pointer-events: auto !important;
          color: #1C1C1C !important;
          font-size: 16px !important;
          font-weight: 400 !important;
        }

        /* Input field */
        ._formFieldContainer_1mxsl_5 > input,
        ._formFieldContainer_1mxsl_5 > textarea {
          padding: 12px 15px !important;
          font-size: 16px !important;
        }

        /* Textarea container */
        ._formFieldContainer_1mxsl_5:has(textarea) {
          align-items: start !important;
        }

        ._formFieldContainer_1mxsl_5:has(textarea) > label {
          padding-top: 12px !important;
        }

        /* Required indicator (*) - Desktop: after input using wrapper */
        ._formFieldContainer_1mxsl_5:has([id="custom#company_name"])::after,
        ._formFieldContainer_1mxsl_5:has([id="custom#full_name"])::after,
        ._formFieldContainer_1mxsl_5:has([id="email"])::after,
        ._formFieldContainer_1mxsl_5:has(textarea)::after {
          content: '*' !important;
          color: #DD251B !important;
          font-family: Camber, sans-serif !important;
          font-weight: 600 !important;
          font-size: 20px !important;
          line-height: 128% !important;
          margin-right: 18px;
        }

        /* Enquiry Details - no asterisk */
        ._formFieldContainer_1mxsl_5:has(textarea)::after {
          font-size: 0 !important;
          width: 10.547px !important;
        }

        /* Error messages - align with input column (250px label + 8px gap) */
        output._formError_1mxsl_21 {
          display: block !important;
          margin-left: 258px !important;
          font-family: Camber, sans-serif !important;
          margin-top: -10px !important;
        }

        /* Consent checkbox fieldset - 2 column grid */
        fieldset[name="custom#consent"] {
          display: grid !important;
          grid-template-columns: 250px 1fr !important;
          gap: 8px !important;
          padding-top: 20px !important;
          padding-bottom: 20px !important;
        }

        fieldset[name="custom#consent"]::before {
          content: '' !important;
          display: block !important;
        }

        fieldset[name="custom#consent"] ._verticalLayout_1hja3_8 {
          grid-column: 2 !important;
          /* width require mask + require mask margin right + gap */
          padding-right: calc(10.547px + 18px + 8px) !important; 
        }

        fieldset[name="custom#consent"] ._checkboxField_1hja3_3 {
          display: flex !important;
          align-items: flex-start !important;
        }

        fieldset[name="custom#consent"] ._checkboxField_1hja3_3 span._textBody_2aowh_10::after {
          content: ' *' !important;
          color: #DD251B !important;
          font-family: Camber, sans-serif !important;
          font-weight: 600 !important;
          font-size: 20px !important;
          line-height: 128% !important;
        }

        /* Consent error - align with checkbox */
        fieldset[name="custom#consent"] output._error_1o4ef_1 {
          grid-column: 2 !important;
          font-family: Camber, sans-serif !important;
          margin-top: -5px !important;
        }

        /* Email consent checkbox - align with input column */
        ._consentCheckboxContainer_cit2d_49 {
          display: grid !important;
          grid-template-columns: 250px 1fr !important;
          gap: 8px !important;
        }

        ._consentCheckboxContainer_cit2d_49::before {
          content: '' !important;
          display: block !important;
        }

        /* Submit button - align with input column */
        button[type="submit"] {
          margin-left: 258px !important;
        }
      }

      /* ========== MOBILE LAYOUT (≤600px) - Stacked ========== */
      @media (max-width: 600px) {
        form {
          padding: 0 3px !important;
          gap: 10px !important;
        }
        /* Form field container - stacked */
        ._formFieldContainer_1mxsl_5 {
          display: flex !important;
          flex-direction: column !important;
          gap: 10px !important;
        }

        /* Label - on top */
        ._formFieldContainer_1mxsl_5 > label._formInputFieldLabel_1mxsl_38 {
          position: static !important;
          transform: none !important;
          order: -1 !important;
          top: auto !important;
          pointer-events: auto !important;
          color: #1C1C1C !important;
          font-size: 13.33px !important;
          font-weight: 400 !important;
        }

        /* Required indicator (*) - Mobile: after label text */
        label[id="label-custom#company_name"]::after,
        label[id="label-custom#full_name"]::after,
        label[id="label-email"]::after {
          content: '*' !important;
          color: #DD251B !important;
          font-family: Camber, sans-serif !important;
          font-weight: 600 !important;
          font-size: 13.33px !important;
          line-height: 128% !important;
          margin-left: 2px !important;
        }

        /* Input field */
        ._formFieldContainer_1mxsl_5 > input,
        ._formFieldContainer_1mxsl_5 > textarea {
          padding: 12px 15px !important;
          font-size: 16px !important;
          width: 100% !important;
          box-sizing: border-box !important;
        }

        /* Consent checkbox - required indicator */

        fieldset[name="custom#consent"] {
          padding-bottom: 10px !important;
        }

        fieldset[name="custom#consent"] ._checkboxField_1hja3_3 span._textBody_2aowh_10::after {
          content: ' *' !important;
          color: #DD251B !important;
          font-family: Camber, sans-serif !important;
          font-weight: 600 !important;
          font-size: 13.33px !important;
          line-height: 128% !important;
        }

        fieldset[name="custom#consent"] ._checkboxField_1hja3_3, fieldset[name="emailConsent"] ._checkboxField_1hja3_3 {
          align-items: start !important;
          gap: 10px !important;
        }

        fieldset[name="custom#consent"] ._checkboxField_1hja3_3 span, fieldset[name="emailConsent"] ._checkboxField_1hja3_3 span {
          font-size: 13.33px !important;
        }

        fieldset[name="custom#consent"] output._error_1o4ef_1 {
          margin-top: 5px !important;
        }

        ._formContainer_1q1d2_30._tight_1q1d2_271 {
          min-height: auto !important;
        }
      }
    `;

    // Inject the style into the shadow root
    shadowRoot.appendChild(style);

    console.log("Contact form button styles injected successfully");
  }

  // Start the process when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", addButtonStyles);
  } else {
    addButtonStyles();
  }
})();
